import React from "react";

export const Dashboard = ({ color = "black" }) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_245_2650)">
        <path
          d="M3.55957 9.75H2.30957C1.2757 9.75 0.43457 8.90887 0.43457 7.875V1.875C0.43457 0.841125 1.2757 0 2.30957 0H3.55957C4.59345 0 5.43457 0.841125 5.43457 1.875V7.875C5.43457 8.90887 4.59345 9.75 3.55957 9.75ZM2.30957 1.25C1.96495 1.25 1.68457 1.53038 1.68457 1.875V7.875C1.68457 8.21963 1.96495 8.5 2.30957 8.5H3.55957C3.9042 8.5 4.18457 8.21963 4.18457 7.875V1.875C4.18457 1.53038 3.9042 1.25 3.55957 1.25H2.30957Z"
          fill={color}
        />
        <path
          d="M8.30957 16H2.30957C1.2757 16 0.43457 15.1589 0.43457 14.125V12.875C0.43457 11.8411 1.2757 11 2.30957 11H8.30957C9.34344 11 10.1846 11.8411 10.1846 12.875V14.125C10.1846 15.1589 9.34344 16 8.30957 16ZM2.30957 12.25C1.96495 12.25 1.68457 12.5304 1.68457 12.875V14.125C1.68457 14.4696 1.96495 14.75 2.30957 14.75H8.30957C8.6542 14.75 8.93457 14.4696 8.93457 14.125V12.875C8.93457 12.5304 8.6542 12.25 8.30957 12.25H2.30957Z"
          fill={color}
        />
        <path
          d="M14.5596 16H13.3096C12.2757 16 11.4346 15.1589 11.4346 14.125V12.875C11.4346 11.8411 12.2757 11 13.3096 11H14.5596C15.5934 11 16.4346 11.8411 16.4346 12.875V14.125C16.4346 15.1589 15.5934 16 14.5596 16ZM13.3096 12.25C12.9649 12.25 12.6846 12.5304 12.6846 12.875V14.125C12.6846 14.4696 12.9649 14.75 13.3096 14.75H14.5596C14.9042 14.75 15.1846 14.4696 15.1846 14.125V12.875C15.1846 12.5304 14.9042 12.25 14.5596 12.25H13.3096Z"
          fill={color}
        />
        <path
          d="M14.5596 9.75H8.55957C7.5257 9.75 6.68457 8.90887 6.68457 7.875V1.875C6.68457 0.841125 7.5257 0 8.55957 0H14.5596C15.5934 0 16.4346 0.841125 16.4346 1.875V7.875C16.4346 8.90887 15.5934 9.75 14.5596 9.75ZM8.55957 1.25C8.21495 1.25 7.93457 1.53038 7.93457 1.875V7.875C7.93457 8.21963 8.21495 8.5 8.55957 8.5H14.5596C14.9042 8.5 15.1846 8.21963 15.1846 7.875V1.875C15.1846 1.53038 14.9042 1.25 14.5596 1.25H8.55957Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_245_2650">
          <rect
            width="16"
            height="16"
            fill={color}
            transform="translate(0.43457)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
